export const LOCAL_STORAGE_KEY_DISPLAY_SETTINGS = 'pokerTimerDisplaySettings';